import styled from 'styled-components/macro';

const getColor = iconName => {
  switch (iconName) {
    case 'settings':
      return 'light-blue';
    case 'check_circle':
      return 'success';
    case 'paid':
      return 'success';
    case 'cancel':
      return 'danger';
    case 'error':
    case 'do_not_disturb':
    case 'watch_later':
      return 'warning';
    case 'lock':
      return 'warning';
    case 'radio_button_checked':
      return 'primary';
    default:
      return 'black';
  }
};
export const I = styled.span`
  font-size: ${props => (props.size ? props.size : '20px')} !important;
  color: ${({ iconName }) => `var(--${getColor(iconName)})`};
  line-height: 1;
  cursor: pointer;
`;

export const IconHolder = styled.div``;
